function checkArray (key) {
    // const response = {
    //     frontPage: ['application', 'secret', 'dashboard'],
    //     resourcePermission: [
    //         {
    //             entity: 'application',
    //             resources: ['appId1', 'appId2', 'appId3'],
    //             actions: {
    //                 application: [
    //                     'generateToken',
    //                     'edit',
    //                     'initCmk'
    //                 ],
    //                 secret: [
    //                     'getValue'
    //                 ],
    //                 policy: [
    //                     'createRole',
    //                     'attach',
    //                     'deleteRoleAndPath',
    //                     'deleteRole'
    //                 ],
    //                 instance: [
    //                     'retry'
    //                 ],
    //                 extend: [
    //                     'delete'
    //                 ]
    //             }
    //         }
    //     ]
    // }
    const arr = localStorage.permission
    // response.frontPage.map(item => {
    //     arr.push('menu-' + item)
    // })
    // response.resourcePermission.map(item => {
    //     item.resources.map(resource => {
    //         Object.keys(item.actions).map(page => {
    //             item.actions[page].map(action => {
    //                 arr.push(page + '-' + action + '-' + item.entity + '-' + resource)
    //             })
    //         })
    //     })
    // })
    if (arr.indexOf(key) !== -1) {
      return true
    } else {
      return false
    }
}

const permission = {
    inserted: function (el, binding) {
        const permission = binding.value
        if (permission) {
            const hasPermission = checkArray(permission)
            if (!hasPermission) {
                el.parentNode && el.parentNode.removeChild(el)
            // } else {
            //     console.log(el, el.parentNode)
                // el.parentNode.appendChild(el)
            }
        }
    }
}

export default permission
